import React from "react";
import "./MenuCard.scss"
import Button from "../Button/Button";
const MenuCard = ({ menu }) => {
    return (
        <div className="VirasatDefault-MenuCard"
            style={{
                backgroundImage: ` linear-gradient(0deg, rgba(0, 0, 0, 0.67) 45.67%, rgba(102, 102, 102, 0) 100%),
url(${menu?.src})`
            }}>
            <div className="VirasatDefault-MenuCard-inner">
                <div className="VirasatDefault-MenuCard-inner-cont">
                    <div className="VirasatDefault-MenuCard-inner-cont-text">
                        {menu?.text}
                    </div>
                    <div className="VirasatDefault-MenuCard-inner-cont-btn">

                        <Button text={menu?.buttonText}
                            onClick={() => {
                                window.open(menu?.href, '_blank')
                            }} />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default MenuCard